import { Record } from 'immutable';

export default Record({
    active: true,
    asin: '',
    id: null,
    keyword: '',
    previousRanking: null,
    productId: null,
    ranking: null,
    salesVelocity: null,
    searchVolume: null,
});

